import { createSlice } from "@reduxjs/toolkit";
import { db } from "../firebase-config";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";

const ItemSlice = createSlice({
  name: 'items',
  initialState: {
    products: [],
    loading: false,
    error: null
  },
  reducers: {
    setProducts: (state, action) => {
      state.products = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state) => {
      state.loading = true;
      state.error = null;
    },
    setError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    }
  }
});

export const { setProducts, setLoading, setError } = ItemSlice.actions;
const productRef=collection(db,"Shagoon");
export const fetchProducts = () => async (dispatch) => {
  const data = await getDocs(productRef);
  try {
    dispatch(setLoading());
     const response= data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
    dispatch(setProducts(response.data));
  } catch (error) {
    dispatch(setError(error.message));
  }
};

export default ItemSlice.reducer;
